import { create } from 'zustand';

interface ReminderTemplatesStore {
  isTableMode: boolean;
  setIsTableMode: (isTableMode: boolean) => void;
  toggleViewMode: () => void;
}

export const useReminderTemplatesStore = create<ReminderTemplatesStore>(
  (set) => ({
    isTableMode: false,
    setIsTableMode: (isTableMode) => set({ isTableMode }),
    toggleViewMode: () =>
      set((state) => ({ isTableMode: !state.isTableMode })),
  })
);
